<template>
  <div class="root">
    <div class="login h-screen">
      <div class="flex  items-center text-center text-2xl">
        <h3>{{ $root.config.appName }}</h3>
      </div>
      <template>
        <form
          @submit="loginRequest()"
          action="javascript:void(0)"
          class="uk-form-stacked"
        >
          <div class="login-marg">
            <label class="uk-form-label">E-Posta</label>
            <div class="uk-form-controls">
              <input
                class="uk-input"
                v-model="form.email"
                placeholder
                type="text"
              />
            </div>
          </div>
          <div class="login-marg">
            <label class="uk-form-label">Şifre</label>
            <div class="uk-form-controls">
              <input
                class="uk-input"
                v-model="form.password"
                placeholder
                type="password"
              />
            </div>
          </div>
          <div class="login-marg">
            <label class="uk-form-controls">
              <input
                class="uk-checkbox"
                value="1"
                name="remember_me"
                type="checkbox"
              />
              Beni hatırla
            </label>
          </div>
          <button type="submit" class="login-button green-button">
            <div class="flex space-x-2 items-center justify-start">
              <span>Giriş yap</span>
            </div>
          </button>
        </form>
        <div v-if="providers.length" class="login-providers">
          <div class="login-providers-sep"><span>veya</span></div>
          <button
            v-for="provider in providers"
            :key="provider.id"
            type="button"
            class="uk-button uk-button-default uk-width-1-1 login-provider-button"
            :disabled="providerLoading === provider.id"
            @click="providerLogin(provider)"
          >
            {{
              providerLoading === provider.id
                ? "Yönlendiriliyor…"
                : provider.name + " ile giriş yap"
            }}
          </button>
        </div>
        <div class="text-xs  mt-2 opacity-30  login-marg">
          <p class="mb-4">
            &copy; {{ year }} crmtronline.com Tüm Hakları Saklıdır.
          </p>

          Powered by
          <a
            class="text-black font-bold"
            target="_blank"
            href="https://viqqa.com/?utm_source=crm"
            >Viqqa</a
          >
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import EventBus from "../components/Ui/EventBus";
import AuthService from "../services/auth";
export default {
  name: "login",
  data() {
    return {
      loading: false,
      year: new Date().getFullYear(),
      form: [],
      messages: [],
      login: false,
      providers: [],
      providerLoading: null,
    };
  },
  created() {
    // Sunucuda yapılandırılmış dış giriş sağlayıcıları (ör. Viqqa). Kapalıysa
    // liste boş gelir ve ek buton gösterilmez.
    AuthService.providers()
      .then((resp) => {
        const list = resp.data && resp.data.success ? resp.data.data : [];
        this.providers = Array.isArray(list) ? list : [];
      })
      .catch(() => {
        this.providers = [];
      });
  },
  mounted() {
    // Viqqa'ya gidip tarayıcının geri tuşuyla dönülürse (bfcache) buton
    // "Yönlendiriliyor…" durumunda kalmasın.
    this.onPageShow = () => {
      this.providerLoading = null;
    };
    window.addEventListener("pageshow", this.onPageShow);
  },
  beforeDestroy() {
    window.removeEventListener("pageshow", this.onPageShow);
  },
  methods: {
    providerLogin(provider) {
      if (provider.id !== "viqqa" || this.providerLoading) return;
      this.providerLoading = provider.id;
      try {
        sessionStorage.setItem("viqqaFlow", "login");
      } catch (e) {
        // yoksay
      }
      AuthService.viqqaStart()
        .then((resp) => {
          if (resp.data && resp.data.success && resp.data.url) {
            window.location.href = resp.data.url;
            return;
          }
          this.providerLoading = null;
          EventBus.$emit("bottomMessage", {
            open: true,
            duration: 4000,
            type: "error",
            title: "Hatalı Giriş",
            body: (resp.data && resp.data.msg) || "Giriş başlatılamadı",
          });
        })
        .catch(() => {
          this.providerLoading = null;
          EventBus.$emit("bottomMessage", {
            open: true,
            duration: 4000,
            type: "error",
            title: "Hatalı Giriş",
            body: "Crm erişim sorunu",
          });
        });
    },
    logout() {
      AuthService.logout();
    },
    loginRequest() {
      this.loading = true;
      this.$parent.$emit("loading", true);
      AuthService.login(this.form)
        .then((resp) => {
          if (resp.data.success === true) {
            this.$parent.$emit("logon", "true");

            EventBus.$emit("bottomMessage", {
              open: true,
              duration: 2000,
              type: "success",
              title: "Giriş",
              body: "Başarılı olarak giriş yaptınız",
            });

            localStorage.setItem("authToken", resp.data.token);

            if (localStorage.authToken) {
              setTimeout(() => {
                window.location.href = "/";
              }, 1000);
              //
            }
          } else {
            EventBus.$emit("bottomMessage", {
              open: true,
              duration: 2000,
              type: "error",
              title: "Hatalı Giriş",
              body: resp.data.msg,
            });
          }
        })
        .catch((resp) => {
          EventBus.$emit("bottomMessage", {
            open: true,
            duration: 2000,
            type: "error",
            title: "Hatalı Giriş",
            body: "Crm erişim sorunu",
          });
        })
        .finally(() => {
          this.loading = false;
          this.$parent.$emit("loading", false);
        });
    },
  },
};
</script>
<style>
.root {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.login {
  width: 350px;
  display: flex;
  flex-direction: column;
  margin-top: 100px;
}

.login-marg {
  margin-bottom: 10px;
}

.login-button {
  margin-top: 10px;
}

.login-providers {
  margin: 14px 0 10px;
}

.login-providers-sep {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 12px;
  opacity: 0.5;
}

.login-providers-sep::before,
.login-providers-sep::after {
  content: "";
  flex: 1;
  border-top: 1px solid currentColor;
}

.login-providers-sep span {
  padding: 0 8px;
}

.login-provider-button {
  margin-bottom: 6px;
  text-transform: none;
}
</style>
